<script setup lang="ts">
import type { CardProps } from '#ui/types';

const cardProps: CardProps = {
  ui: {
    root: 'relative isolate w-full h-full bg-neutral-900/60 backdrop-blur-lg overflow-hidden',
  },
};
</script>

<template>
  <UCard v-bind="cardProps">
    <div
      class="relative z-[2] grid grid-cols-1 items-center gap-4 md:grid-cols-3"
    >
      <div class="col-span-2 w-full max-w-prose space-y-1">
        <USkeleton class="h-4 w-1/6" />
        <USkeleton class="mb-2 h-8 w-2/3" />
        <USkeleton class="h-4 w-full" />
        <USkeleton class="h-4 w-1/3" />
      </div>
      <UCard
        :ui="{
          root: 'relative isolate bg-neutral-950/60 backdrop-blur-lg overflow-hidden shadow-lg',
        }"
      >
        <div class="relative z-[2] space-y-2 text-center">
          <div class="space-y-2">
            <USkeleton class="mx-auto h-12 w-1/4" />
            <USkeleton class="mx-auto h-4 w-1/3" />
            <USkeleton class="h-10 w-full" />
          </div>
        </div>
      </UCard>
    </div>
  </UCard>
</template>
